import React from "react";
import selfPhotoFallback from "../../assets/self-photo.jpeg";

const s3PhotoUrl = `${process.env.REACT_APP_AWS_URL}/static/portfolio_app/self-photo.jpeg`;

const CHIPS = ["Data Analytics", "Data Engineering", "Dashboards", "Data Literacy", "Startups"];

function AboutMarielle() {
  return (
    <div className="about-page">
      <div className="about-photo-wrap">
        <img
          alt="Marielle Nwana"
          src={s3PhotoUrl}
          onError={(e) => { e.target.onerror = null; e.target.src = selfPhotoFallback; }}
        />
        <div className="about-badge">
          NYC-based{"\n"}Data Engineer
        </div>
      </div>

      <div className="about-content">
        <p className="about-eyebrow">About me</p>
        <h1 className="about-headline">
          Making data <em>accessible</em> for everyone
        </h1>
        <p className="about-body">
          My experience includes leading projects within data teams from data
          ingestion to analysis, presenting data driven insights to leadership,
          and partnering across engineering, business and sales teams to transform
          raw data into data tools and dashboards for internal and external
          measurement. I thrive in high-growth environments where there is
          a healthy balance of collaboration and autonomy.
        </p>
        <p className="about-body">
          When I'm not working, I enjoy trying out new recipes, playing with
          my cat Molly, and exploring all that the Big Apple has to offer.
        </p>
        <div className="about-chips">
          {CHIPS.map((c) => <span key={c} className="about-chip">{c}</span>)}
        </div>
        <ul className="about-social">
          <li><a href="mailto:marielle@gooddistractions.com">Email</a></li>
          <li><a href="https://www.github.com/mnwana" target="_blank" rel="noreferrer">GitHub</a></li>
          <li><a href="https://www.linkedin.com/in/mnwana" target="_blank" rel="noreferrer">LinkedIn</a></li>
          <li><a href="https://www.instagram.com/marntech" target="_blank" rel="noreferrer">Instagram</a></li>
        </ul>
      </div>
    </div>
  );
}

export default AboutMarielle;
